import { Component, OnInit } from '@angular/core';
import { ImportLinesheetComponent } from 'gung-standard';
import { first, forkJoin, map } from 'rxjs';

@Component({
  selector: 'otto-olsen-import-linesheet',
  templateUrl: './otto-olsen-import-linesheet.component.html',
  styleUrl: './otto-olsen-import-linesheet.component.scss',
  standalone: false
})
export class OttoOlsenImportLinesheetComponent extends ImportLinesheetComponent implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();
    this.selectFormat(this.COLUMN_FORMAT);
  }

  uploadFileColumn(files: File[]) {
    this.loading = true;
    const formData = new FormData();
    for (const file of files) {
      formData.append('file', file);
    }
    forkJoin({
      customerProducts: this.productService.getCustomerSpecificProductData().pipe(first()),

      linesheetImport: this.linesheetService
        .cartsMatchProducts(this.selectedAssortment.id, this.selectedFlow.id, formData, this.selectedCustomer.id)
        .pipe(
          first(),
          map(res => {
            const result = structuredClone(res);
            for (let index = res.mapped.length - 1; index >= 0; index--) {
              const element = res.mapped[index];
              const itemType = String(element.product.extra.ar.itemtypecd1);

              if (itemType === '0' || itemType === '7') {
                result.mapped.splice(index, 1);
                result.errors.push(
                  `Product found for row #${element.rowCount} with id ${element.productId} but is blocked`
                );
              }
            }
            return result;
          })
        )
    }).subscribe(this.getImportResultHandler());
  }

  override getImportResultHandler() {
    return {
      next: ({ linesheetImport, customerProducts }) => {
        const event = linesheetImport;

        if (!event || typeof event !== 'object') {
          this.loading = false;
          return;
        }

        this.result = {
          errors: event.errors,
          rows: (event.mapped || []).map(r => ({
            rownr: r.rowCount,
            productId: r.productId,
            quantity: r.amount,
            eanCode: r.eanCode,
            product: r.product,
            discountPercent: r.discountPercent,
            externalPrice: r.externalPrice,
            customerSpecific: customerProducts?.[r.productId] || null,
            customerReferenceId:
              r.customerReferenceId ||
              customerProducts?.[r.productId]?.customerReferenceId ||
              customerProducts?.[r.productId]?.customerProductId ||
              null
          }))
        };

        if (!this.isSalesOrAdmin) {
          this.checkQuantity();
        } else {
          this.loading = false;
        }
      },
      err: () => {
        this.loading = false;
      }
    };
  }
}
